export default (theme) => ({
  root: {
    border: '1px solid lightgrey',
    borderRadius: '3px',
    overflow: 'auto',
  },
  tableHeader: {
    backgroundColor: theme.palette.common.white,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: 0,
  },
  toggleButton: {
    float: 'right',
  },
});
